export default {
  data: () => {
    return {
      customTooltipMixin: {
        // Disable the on-canvas tooltip
        enabled: false,
        callbacks: {
          // Use the footer callback to display the sum of the items showing in the tooltip
          label: function (tooltipItems, data) {
            let processName = data.datasets[tooltipItems.datasetIndex].label
            let value =
              data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index]

            return `${processName}: ${value}`
          }
        },
        custom: function (tooltipModel) {
          // Tooltip Element
          let tooltipEl = document.getElementById('chartjs-tooltip')
          let processName = ''
          let displayVal = ''
          if (tooltipModel.dataPoints) {
            let processIdx = tooltipModel.dataPoints[0].datasetIndex
            processName = this._data.datasets[processIdx].label
            displayVal = tooltipModel.dataPoints[0].yLabel
          }

          let subtitle = this._chart.options.subtitle || ''

          // Create element on first render
          if (!tooltipEl) {
            tooltipEl = document.createElement('div')
            tooltipEl.id = 'chartjs-tooltip'
            tooltipEl.innerHTML = '<table></table>'
            document.body.appendChild(tooltipEl)
          }
          // Hide if no tooltip
          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0
            return
          }

          // Set caret Position
          tooltipEl.classList.remove('above', 'below', 'no-transform')
          if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign)
          } else {
            tooltipEl.classList.add('no-transform')
          }

          // Set Text
          if (tooltipModel.body) {
            let titleLines = [processName]
            titleLines = titleLines.concat(tooltipModel.title)

            let bodyLines = [`${subtitle}: ${displayVal}`]

            let innerHtml = '<thead>'

            titleLines.forEach(function (title) {
              innerHtml += '<tr><th>' + title + '</th></tr>'
            })
            innerHtml += '</thead><tbody>'

            bodyLines.forEach(function (body, i) {
              let span = '<span></span>'
              innerHtml += '<tr><td>' + span + body + '</td></tr>'
            })
            innerHtml += '</tbody>'

            let tableRoot = tooltipEl.querySelector('table')
            tableRoot.innerHTML = innerHtml
          }

          // `this` will be the overall tooltip
          let position = this._chart.canvas.getBoundingClientRect()

          // Display, position, and set styles for font
          tooltipEl.style.opacity = 1
          tooltipEl.style.backgroundColor = 'black'
          tooltipEl.style.color = 'white'
          tooltipEl.style.borderRadius = '%5'
          tooltipEl.style.position = 'absolute'
          tooltipEl.style.left =
            position.left + window.pageXOffset + tooltipModel.caretX / 2 + 'px'
          tooltipEl.style.top =
            position.top + window.pageYOffset + tooltipModel.caretY / 2 + 'px'
          tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily
          tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px'
          tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle
          tooltipEl.style.padding =
            tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px'
          tooltipEl.style.pointerEvents = 'none'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/chartTooltipOptionMixin.js